export default "__VITE_ASSET__B$DQZcis__"